export default "__VITE_ASSET__Nfpl4hEv__"